import { Certification } from 'src/app/people/models/certification';
import {
  AutomationConditionItem,
  AutomationConditionModel,
} from 'src/app/shared/components/automation-condition-builder/automation-condition.model';
import { ODataFilterValues } from 'src/app/shared/components/odata-filter/models/odata-filter';
import { SearchValueType } from 'src/app/shared/components/odata-filter/models/search-value-type';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';

export enum EvidenceAutomationActionType {
  Autocomplete = 'Autocomplete',
  /** not implemented yet */
  Flag = 'Flag',
}

export const AutomationActionTypeToText: Record<EvidenceAutomationActionType, string> = {
  Autocomplete: 'Autocomplete requirement',
  Flag: 'Flag',
};
export class RequirementAutomation {
  id: string;
  automationActionType: EvidenceAutomationActionType;
  conditions: AutomationConditionModel[];
}
export class EvidenceAutomationConditionItem implements AutomationConditionItem {
  /**not used? */
  public id: string;
  public objectId: string;
  public displayName: string;
  public values: any[] | ODataFilterValues[];
  public valueType: SearchValueType;
  public subConditionItems?: AutomationConditionItem[];
  private _conditionReady: () => void;
  constructor(objectId: string, displayName: string, conditionReady: () => void) {
    this.objectId = objectId;
    this.displayName = displayName;
    this._conditionReady = conditionReady;
  }

  setValueType = (valueType: SearchValueType) => {
    this.valueType = valueType;
    this._conditionReady();
  };

  setAttributeValues = (attribute: AttributeDefinition) => {
    if (!attribute) {
      this._conditionReady();
      return;
    }
    this.values = attribute.valueList.map(
      (value) => new ODataFilterValues(value.id, value.itemValue)
    );
    if (attribute.uiType == AttributeUiType.Skill) {
      // This if statement treated 'uiType == AttributeUiType.Skill' differently than AttributeDefinition.getSearchValueType
      return this.setValueType(SearchValueType.MultiValue); //should double check that this is correct.
    }

    if (attribute.uiType === AttributeUiType.Complex) {
      this.subConditionItems = attribute.subFieldList.map((sub) => {
        const subCondition = new EvidenceAutomationConditionItem(
          sub.id,
          sub.subFieldDefinition.name,
          this._conditionReady
        );
        subCondition.setAttributeValues(sub.subFieldDefinition);
        return subCondition;
      });
      return this.setValueType(SearchValueType.EmptyOperator);
    }
    const valueType = AttributeDefinition.getSearchValueType(attribute);
    if (valueType) {
      return this.setValueType(valueType);
    }

    console.error(
      `could not find SearchValueType for ${JSON.stringify(
        this
      )} and AttributeDefinition ${JSON.stringify(attribute)}. Treating as string`
    );
    this.setValueType(SearchValueType.String);
  };

  setCertificationValues(certifications: Certification[]) {
    this.values = certifications.map(
      (certification) => new ODataFilterValues(certification.id, certification.name)
    );
    this.setValueType(SearchValueType.MultiValue);
  }
}
